import { PlantInfoData } from './detailed-info';
import { Sensor } from './sensors-response';
import { SiteInfoData } from './site-info-response';
import { Phase } from './stats';



export enum TrendSelection {
  DAY = 'DAY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
  CUSTOM = 'CUSTOM',
}

export enum TrendType {
  POWER_GENERATION = 'POWER_GENERATION',
  POWER_CONSUMPTION = 'POWER_CONSUMPTION',
  POWER_CUT = 'POWER_CUT',
}

export enum StringInfoType {
  VOLTAGE = 'VOLTAGE',
  CURRENT = 'CURRENT',
  POWER = 'POWER',
}
export enum DetailInfoType {
  LOAD = 'LOAD',
  SOLAR = 'SOLAR',
  GRID = 'GRID',
  BATTERY = 'BATTERY'
}
export enum FAQType {
  faq,
  dos,
  dont,
}
export enum NoxInverterType {
  GTI = 'GTI',
  THINKPOWER = 'ThinkPower',
  PCU = 'PCU',
  REGALIA_W = 'REGALIA W',
  REGALIA_F = 'REGALIA F',
  ZELIO = 'ZELIO',
  ZELIO_WIFI_V2 = 'ZELIO WIFI V2',
  ICRUZE = 'ICRUZE',
  SOLARVERTERPRO = 'SOLARVERTERPRO',
  HYBRID = 'HYBRID',
  LIIONSOLARVERTER = 'LIIONSOLARVERTER',
  LITHIUMVERTER = 'LITHIUMVERTER',
  OPTIMUS = 'OPTIMUS',
  BATTERY = 'BATTERY',
  THINKPOWER_HEMS = "THINKPOWER_HESM",
  ENERTECH_SOLAR = "L_ENERTECH_3P_HYBRID",
  ENERTECH_NON_SOLAR = "A_ENERTECH_3P_NON_SOLAR",
  OPTIMUS_3P = "OPTIMUS_3P_NON_SOLAR",
  ARCTIC_HYBRID = "ARCTIC_HYBRID"
}

export enum NoxAlertType {
  SHORT_CIRCUIT = 'Short Circuit',
  INVERTER_OVERHEATED = 'Inverter Overheated',
  SHORT_CIRCUIT_AND_INVERTER_OVERHEATED = 'Short Circuit and Inverter Overheated',
  BATTERY_DETECTED_HIGH_VOLTAGE = 'Battery Detected and High Voltage',
  BATTERY_DETECTED_HIGH_TEMPERATURE = "Battery Detected and High Temperature",
  OFFLINE = 'Offline',
}
export enum VerificationType {
  SendOtp = 'sendotp',
  ResendOtp = 'resendotp'
}
export enum SelectionType {

  yearly = "YEARLY",
  monthly = "MONTHLY",
  notification = "NOTIFICATION",
  trendType = "TREND_TYPE"


}
export enum PlantDetailInformationType {
  siteDetails = "siteDetails",
  inverterDetails = "inverterDetails",
  batteryDetails = "batteryDetails",
  solarPVDetails = "solarPvDetails",
  dataLoggerDetails = "dataLoggerDetails",
  connectedUser = "connectedUser",
  downloadReport = "downloadReport"
}
export enum Password {
  newPassword = 1,
  confirmNewPassword = 2
}

export enum HoliumPlantType {
  haridwar = '1',
  rudrapur = '2',
  baddi = '3'
}
export enum TOKEN_KEYS {
  haridwar = 'HARIDWAR_PLANT_TOKEN',
  rudrapur = 'RUDRAPUR_PLANT_TOKEN',
  baddi = 'BADDI_PLANT_TOKEN',
};
export enum WEB_DYN {
  token = 'WEB_DYN_TOKEN',
};
export enum PLANT_TYPE {
  solar = 'SOLAR',
  nonSolar = 'NON SOLAR'
};

export interface TabItem {
  label: string;
  unit: string;
  key?: keyof PlantInfoData;
  pvIndex?: number;
  pvField?: 'voltage' | 'current' | 'power';
}


export const loadTab: TabItem[] = [
  { label: 'Output Voltage R-Phase', key: 'inverterVoltageR', unit: ' V' },
  { label: 'Output Voltage Y-Phase', key: 'inverterVoltageY', unit: ' V' },
  { label: 'Output Voltage B-Phase', key: 'inverterVoltageB', unit: ' V' },
  { label: 'Output Current R-Phase', key: 'inverterCurrentR', unit: ' A' },
  { label: 'Output Current Y-Phase', key: 'inverterCurrentY', unit: ' A' },
  { label: 'Output Current B-Phase', key: 'inverterCurrentB', unit: ' A' },
  { label: 'Load Power R-Phase', key: 'loadPowerR', unit: ' kW' },
  { label: 'Load Power Y-Phase', key: 'loadPowerY', unit: 'kW' },
  { label: 'Load Power B-Phase', key: 'loadPowerB', unit: ' kW' },
   { label: 'Load', key: 'loadPercentage', unit: '%' },
  { label: 'Total Load Power', key: 'totalInverterPower', unit: ' kW' },
  { label: 'Inverter Frequency', key: 'inverterFrequency', unit: ' Hz' },
  { label: 'Inverter Temperature', key: 'hsTemp', unit: '°C' },
];
export const optimusLoadTab: TabItem[] = [
  { label: 'Output Voltage R-Phase', key: 'inverterVoltageR', unit: ' V' },
  { label: 'Output Voltage Y-Phase', key: 'inverterVoltageY', unit: ' V' },
  { label: 'Output Voltage B-Phase', key: 'inverterVoltageB', unit: ' V' },
  { label: 'R-Phase Load %', key: 'loadPercentageR', unit: '%' },
  { label: 'Y-Phase Load %', key: 'loadPercentageY', unit: '%' },
  { label: 'B-Phase Load %', key: 'loadPercentageB', unit: '%' },
  { label: 'Load Power R-Phase', key: 'loadPowerR', unit: ' kW' },
  { label: 'Load Power Y-Phase', key: 'loadPowerY', unit: ' kW' },
  { label: 'Load Power B-Phase', key: 'loadPowerB', unit: ' kW' },
  { label: 'Total Load Power', key: 'totalInverterPower', unit: ' kW' },
  { label: 'Inverter FrequencyR', key: 'inverterFrequencyR', unit: ' Hz' },
  { label: 'Inverter FrequencyY', key: 'inverterFrequencyY', unit: ' Hz' },
  { label: 'Inverter FrequencyB', key: 'inverterFrequencyB', unit: ' Hz' },
]

export const arcticOnePhaseLoadTab: TabItem[] = [
  { label: 'Output Voltage', key: 'inverterVoltageR', unit: ' V' },
  { label: "Output Current", key: 'inverterCurrentR', unit: ' A' },
  { label: 'Total Load Power', key: 'totalOutputPower', unit: ' VA' },
  { label: "Today's Load Energy", key: 'todayLoadEnergy', unit: ' kWh' },
  { label: "Lifetime Load Energy", key: 'lifeTimeConsumption', unit: ' kWh' },
  { label: 'Inverter Frequency', key: 'inverterFrequency', unit: ' Hz' },
  { label: 'Inverter Temperature', key: 'hsTemp', unit: ' °C' }
]
export const arcticThreePhaseLoadTab: TabItem[] = [
  { label: 'Output Voltage R-Phase', key: 'inverterVoltageR', unit: ' V' },
  { label: 'Output Voltage Y-Phase', key: 'inverterVoltageY', unit: ' V' },
  { label: 'Output Voltage B-Phase', key: 'inverterVoltageB', unit: ' V' },
  { label: 'Output Current R-Phase', key: 'inverterCurrentR', unit: ' A' },
  { label: 'Output Current Y-Phase', key: 'inverterCurrentY', unit: ' A' },
  { label: 'Output Current B-Phase', key: 'inverterCurrentB', unit: ' A' },
  { label: 'Load Power R-Phase', key: 'loadPowerR', unit: ' W' },
  { label: 'Load Power Y-Phase', key: 'loadPowerY', unit: ' W' },
  { label: 'Load Power B-Phase', key: 'loadPowerB', unit: ' W' },
  { label: 'Total Load Power', key: 'totalOutputPower', unit: ' VA' },
  { label: "Today's Load Energy", key: 'todayLoadEnergy', unit: ' kWh' },
  { label: "Lifetime Load Energy", key: 'lifeTimeConsumption', unit: ' kWh' },
  { label: 'Inverter Frequency', key: 'inverterFrequency', unit: ' Hz' },
  { label: 'Inverter Temperature', key: 'hsTemp', unit: ' °C' }
]
export const solarTab: TabItem[] = [
  { label: 'Solar Voltage', key: 'solarVoltage', unit: ' V' },
  { label: 'Solar Current', key: 'solarCurrent', unit: ' A' },
  { label: 'Solar Power', key: 'solarPower', unit: ' kW' },
  { label: 'Today Generation', key: 'todaySolarGeneration', unit: ' kW' },
  { label: 'Lifetime Solar Energy Generation', key: 'lifeTimeSolarEnergyGeneration', unit: '' }
];


 
export const arcticSolarTab: TabItem[] = [
  { label: 'Solar Power', key: 'solarPower', unit: ' W' },
  { label: 'Today Generation', key: 'todaySolarGeneration', unit: ' kWh' },
    { label: 'Lifetime Solar Energy Generation', key: 'lifeTimeSolarEnergyGeneration', unit: '' },
 
  { label: 'PV1 Voltage', pvIndex: 0, pvField: 'voltage', unit: ' V' },
  { label: 'PV1 Current', pvIndex: 0, pvField: 'current', unit: ' A' },
  { label: 'PV1 Power', pvIndex: 0, pvField: 'power', unit: ' W' },
 
  { label: 'PV2 Voltage', pvIndex: 1, pvField: 'voltage', unit: ' V' },
  { label: 'PV2 Current', pvIndex: 1, pvField: 'current', unit: ' A' },
  { label: 'PV2 Power', pvIndex: 1, pvField: 'power', unit: ' W' },
 
  { label: 'PV3 Voltage', pvIndex: 2, pvField: 'voltage', unit: ' V' },
  { label: 'PV3 Current', pvIndex: 2, pvField: 'current', unit: ' A' },
  { label: 'PV3 Power', pvIndex: 2, pvField: 'power', unit: ' W' },
 
  { label: 'PV4 Voltage', pvIndex: 3, pvField: 'voltage', unit: ' V' },
  { label: 'PV4 Current', pvIndex: 3, pvField: 'current', unit: ' A' },
  { label: 'PV4 Power', pvIndex: 3, pvField: 'power', unit: ' W' },
];
 
export const gridTab: TabItem[] = [
  { label: 'Grid Voltage R-Phase', key: 'inputVoltageR', unit: ' V' },
  { label: 'Grid Voltage Y-Phase', key: 'inputVoltageY', unit: ' V' },
  { label: 'Grid Voltage B-Phase', key: 'inputVoltageB', unit: ' V' },
  { label: 'Grid Current R-Phase', key: 'inputCurrentR', unit: ' A' },
  { label: 'Grid Current Y-Phase', key: 'inputCurrentY', unit: ' A' },
  { label: 'Grid Current B-Phase', key: 'inputCurrentB', unit: ' A' },
  { label: 'Total Grid Power', key: 'totalInputPower', unit: ' kW' },
  { label: 'Grid Frequency', key: 'inputFrequency', unit: ' kW' },
  { label: 'Lifetime Grid Imported Energy', key: 'totalGrid', unit: ' kW' },
  { label: 'Lifetime Grid Export Energy', key: 'totalGridExport', unit: ' kWh' }
];
export const optimusGridTab: TabItem[] = [
  { label: 'Grid Voltage R-Phase', key: 'inputVoltageR', unit: ' V' },
  { label: 'Grid Voltage Y-Phase', key: 'inputVoltageY', unit: ' V' },
  { label: 'Grid Voltage B-Phase', key: 'inputVoltageB', unit: ' V' },
  { label: 'Grid Frequency R-Phase', key: 'gridFrequencyR', unit: ' Hz' },
  { label: 'Grid Frequency Y-Phase', key: 'gridFrequencyY', unit: 'Hz' },
  { label: 'Grid Frequency B-Phase', key: 'gridFrequencyB', unit: 'Hz' }
]

export const arcticOnePhaseGridTab: TabItem[] = [
  { label: 'Grid Voltage', key: 'inputVoltageR', unit: ' V' },
  { label: 'Grid Current', key: 'inputCurrentR', unit: ' A' },
  { label: 'Grid Frequency', key: 'gridFrequencyR', unit: ' Hz' },
    { label: 'Total Active Power', key: 'totalInputPower', unit: ' W' },
  { label: 'Total Reactive Power', key: 'totalReactivePower', unit: ' var' },
  { label: "Today's Exported energy", key: 'totalGridExport', unit: ' kWh' },
  { label: " Today's Imported Energy", key: 'totalGrid', unit: ' kWh' },
  { label: "Lifetime Exported Energy  ", key: 'lifetimeExportEnergy', unit: ' kWh' },
  { label: "Lifetime Imported Energy", key: 'lifetimeImportedEnergy', unit: ' kWh' },

]
export const arcticThreePhaseGridTab: TabItem[] = [
 { label: 'Grid Voltage R-Phase', key: 'inputVoltageR', unit: ' V' },
  { label: 'Grid Voltage Y-Phase', key: 'inputVoltageY', unit: ' V' },
  { label: 'Grid Voltage B-Phase', key: 'inputVoltageB', unit: ' V' },
  { label: 'Grid Current R-Phase', key: 'inputCurrentR', unit: ' A' },
  { label: 'Grid Current Y-Phase', key: 'inputCurrentY', unit: ' A' },
  { label: 'Grid Current B-Phase', key: 'inputCurrentB', unit: ' A' },
   { label: 'Grid Frequency R-Phase', key: 'gridFrequencyR', unit: ' Hz' },
  { label: 'Grid Frquency Y-Phase', key: 'gridFrequencyY', unit: ' Hz' },
  { label: 'Grid Frequency B-Phase', key: 'gridFrequencyB', unit: ' Hz' },
   { label: 'Grid Power R-Phase', key: 'inputPowerR', unit: ' W' },
  { label: 'Grid Power Y-Phase', key: 'inputPowerY', unit: ' W' },
  { label: 'Grid Power B-Phase', key: 'inputPowerB', unit: ' W' },
   { label: 'Total Active Power', key: 'totalInputPower', unit: ' W' },
  { label: 'Total Reactive Power', key: 'totalReactivePower', unit: ' var' },
  { label: "Today's Exported energy", key: 'totalGridExport', unit: ' kWh' },
  { label: " Today's Imported Energy", key: 'totalGrid', unit: ' kWh' },
  { label: "Lifetime Exported Energy  ", key: 'lifetimeExportEnergy', unit: ' kWh' },
  { label: "Lifetime Imported Energy", key: 'lifetimeImportedEnergy', unit: ' kWh' },
]
export const batteryTab: TabItem[] = [
  { label: 'Battery Voltage', key: 'batteryVoltage', unit: ' V' },
  { label: 'Battery Charging Current', key: 'batteryChargingCurrent', unit: ' A' },
  { label: 'Battery Discharging Current', key: 'batteryDischargingCurrent', unit: ' A' },
  { label: 'Battery %', key: 'batteryPercentage', unit: ' %' }
];
export const optimusBatteryTab: TabItem[] = [
  { label: 'Battery Voltage', key: 'batteryVoltage', unit: ' V' },
  { label: 'Battery Charging Current', key: 'batteryChargingCurrent', unit: ' A' },
  { label: 'Battery Discharging Current', key: 'batteryDischargingCurrent', unit: ' A' },
]
export const arcticBatteryTab: TabItem[] = [
{ label: 'Battery Voltage', key: 'batteryVoltage', unit: ' V' },
{ label: 'Battery Current', key: 'batteryChargingCurrent', unit: ' A' },
{ label: 'Battery Power', key: 'batteryPower', unit: ' W' },
{ label: 'Battery SOC', key: 'batteryPercentage', unit: ' %'  },
{ label: 'Battery SOH', key: 'batterySOH', unit: ' %'  },
{ label: 'Battery State', key: 'batteryState', unit: ''  },
{ label: 'Battery Temperature', key: 'batteryTemperature', unit: ' °C'  },
{ label: 'Energy Charged Today', key: 'energyChargedToday', unit: ' kWh'  },
{label: 'Energy Discharged Today', key: 'energyDischargedToday', unit:' kWh'},
{label: 'Lifetime Charged Energy', key: 'lifetimeChargedEnergy', unit:' kWh'  },
{label: 'Lifetime   Discharged Energy', key: 'lifetimeDischargedEnergy', unit:' kWh'  },
]
export interface PhaseItemList{
  label:string;
  key:keyof Phase;
}
export const phaseList: PhaseItemList[] = [
  { label: 'R', key: 'phaseRVoltage' },
  { label: 'Y', key: 'phaseYVoltage' },
  { label: 'B', key: 'phaseBVoltage' },
];
export interface SiteInfo {
  label: string;
  key: keyof SiteInfoData;

}
export const siteInfoRows: SiteInfo[] = [
  { label: 'Site Name', key: 'siteName' },
  { label: 'Capacity', key: 'capacity' },
  { label: 'Commissioning Date', key: 'commissioningDate' },
  { label: 'PV Modules Make', key: 'pvModulesMake' },
  { label: 'PV Modules Quantity', key: 'pvModulesQuantity' },
  { label: 'PV Modules Wattage', key: 'pvModulesWattage' }
];

export interface SensorRow {
  label: string;
  key: keyof Sensor;
  unit: string;
}

export const sensorRows: SensorRow[] = [
  { label: 'Sensor Name', key: 'sensorName', unit: '' },
  { label: 'Irradiation', key: 'irradiation', unit: 'Wh/m2' },
  { label: 'Wind Direction', key: 'windDirection', unit: '°' },
  { label: 'Wind Speed', key: 'windSpeed', unit: 'm/s' },
  { label: 'Ambient Temperature', key: 'ambientTemperature', unit: '°C' },
  { label: 'Module Temperature', key: 'moduleTemperature', unit: '°C' },
  { label: 'Last Updated', key: 'lastUpdated', unit: '' }
];

export const meterHeaderLabels: Record<string, string> = {
  parameter: 'Parameter',
  activePower: 'Active Power (kW)',
  reactivePower: 'Reactive Power (kVar)',
  powerFactor: 'Power Factor',
  importEnergy: 'Import Energy (kWh)',
  exportEnergy: 'Export Energy (kWh)',
  peakPower: 'Peak Power (kW)',
  lastUpdated: 'Last Updated'
};
export interface TabCache<T> {
  data: T;
  plantId: string;
  lastFetched: number;
  lastVisited: number;
}

export enum TabType {
  INVERTER_STRING = 'inverterString',
  METERS = 'meters',
  SENSORS = 'sensors',
  SITE_INFO = 'siteInfo'
}
export const gtiHeaderKeys= ["Strings","Voltage (V)","Current (A)","Power (kW)"];
export const headerKeys=["Photovoltaic","Voltage (V)","Current (A)","Power (kW)"]